import { render, staticRenderFns } from "./FolderMenu_v2.vue?vue&type=template&id=47ac2dbc&scoped=true"
import script from "./FolderMenu_v2.vue?vue&type=script&lang=js"
export * from "./FolderMenu_v2.vue?vue&type=script&lang=js"
import style0 from "./FolderMenu_v2.vue?vue&type=style&index=0&id=47ac2dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac2dbc",
  null
  
)

export default component.exports